import React from 'react';
import { SecuritySection } from './SecuritySection';
import { DevicesSection } from './DevicesSection';

/**
 * Security Tab
 * Contains security/password settings and the list of connected devices
 */
export const SecurityTab: React.FC = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8 py-8">
      <div className="space-y-6">
        <SecuritySection />
        <DevicesSection />
      </div>
    </div>
  );
};
